import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { BLOG_ACTION_TYPE, BlogAction } from "./blog.action";
import { BlogService } from "./blog.service";

/**
 * @deprecated [fabric-deprecated] - use fabric BlogService from app-site instead
 */
@Injectable()
export class BlogEffect {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(SiteAppCommand.GetAllBlogPosts)" instead
	 */
	getAll$ = createEffect(() =>
		this.actions$.pipe(
			ofType(BLOG_ACTION_TYPE.getFeed),
			map((x: ActionWithPayload) => x.payload),
			switchMap((x) =>
				this.service.getFeed(x).pipe(
					map((feed) => this.action.getFeedSuccess(feed)),
					catchError((error: AppError) => of(this.action.getFeedFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private action: BlogAction,
		private service: BlogService
	) {}
}
